<template>
  <div class="festival" v-if="FestivalHomeData">
    <HeadBlock />

    <!-- 輪播 -->
    <div class="carousel_box" v-if="carouselItems">
      <div>
        <VueSlickCarousel :arrows="true" :dots="true">
          <div class="img_box" v-for="(carousel, carouselIndex) in carouselItems" :key="carouselIndex">
            <img :src="carousel.Src" :alt="carousel.title">
          </div>
        </VueSlickCarousel>
      </div>
    </div>

    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <div class="container">
          <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
          <li class="breadcrumb-item active" aria-current="page">{{ $t('國際音樂節') }}</li>
        </div>
      </ol>
    </nav>
    <a accesskey="c" id="accesskey_c" href="#" title="中間主要內容區">
      :::
    </a>
    <div class="main festivalActivity" v-if="FestivalHomeData.EventSeries_Category">
      <div class="container">
        <div class="title">
          <h2>{{ FestivalHomeData.EventSeries_Category.CategoryName }}</h2>
        </div>
        <ul class="list row">
          <li class="col-12 col-md-6 col-lg-4 " v-for="Post in Posts" :key="Post.PId">
            <a :href="gotoPostLink(Post)" :target="Post.Type == 1 && Post.Blank ? '_blank' : ''"
              :title="Post.Title + (Post.Type == 1 && Post.Blank ? ', 另開新視窗' : '')" style="width: 100%;">
              <div class="img_box">
                <img :src="FestivalHomeData.SiteUrl + Post.Image" :alt="Post.Title">
              </div>
              <p class="list_title">
                {{ Post.Title }}
              </p>
              <p class="time">
                {{ Post.SimpleContent }}
              </p>
            </a>
          </li>
        </ul>
        <ul class="page_box">
          <li class="prev" :class="pageNow - 1 < 1 ? 'disabled' : ''">
            <a title="上一頁" href="javascript:void(0)"
              @click="pageNow - 1 >= 1 ? loadList(pageNow - 1) : loadList(pageNow)">&lt;</a>
          </li>
          <!-- 第一頁 -->
          <li class="page" :class="pageNow == 1 ? 'active' : ''">
            <a title="第 1 頁" href="javascript:void(0)" @click="loadList(1)">1</a>
          </li>
          <!-- 左側省略號 -->
          <li class="page disabled" v-if="startPage > 2">
            <a class="">…</a>
          </li>
          <!-- 中間頁面 -->
          <li class="page" :class="index === pageNow ? 'active' : ''" v-for="index in visiblePages" :key="index">
            <a :title="'第 ' + index + ' 頁'" href="javascript:void(0)" @click="loadList(index)">{{ index }}</a>
          </li>
          <!-- 右側省略號 -->
          <li class="page disabled" v-if="endPage < pageAll - 1">
            <a class="">…</a>
          </li>
          <!-- 最後一頁 -->
          <li class="page" :class="pageNow == pageAll ? 'active' : ''" v-if="pageAll > 1">
            <a :title="'第 ' + pageAll + ' 頁'" href="javascript:void(0)" @click="loadList(pageAll)">{{ pageAll }}</a>
          </li>
          <li class="next" :class="pageNow + 1 > pageAll ? 'disabled' : ''">
            <a tabindex="0" title="下一頁" href="javascript:void(0)"
              @click="pageNow + 1 <= pageAll ? loadList(pageNow + 1) : loadList(pageNow)">&gt;</a>
          </li>
        </ul>
      </div>
    </div>

    <FestivalFooterBlock />
  </div>
</template>
<script>
import HeadBlock from "@/components/HeadBlock.vue";
import FooterBlock from "@/components/FooterBlock.vue";
import FestivalFooterBlock from "@/components/FestivalFooterBlock.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "金曲獎": "金曲獎",
    "金曲國際音樂節": "金曲國際音樂節",
  },
  en: {
    "首頁": "Home",
    "金曲獎": "Golden Melody Awards",
    "金曲國際音樂節": "Golden Melody Festival",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "FestivalHome",
  i18n,
  components: {
    Slick,
    HeadBlock,
    FooterBlock,
    FestivalFooterBlock,
    VueSlickCarousel,
  },
  data() {
    return {
      FestivalHomeData: null,
      carouselItems: null,
      Keyword: "",
      Posts: null,
      pageAll: 0,
      perPage: 10,
      pageNow: 1,
      total: 0,
      maxVisiblePages: 5,
      local: "zh_tw",
      Posts_All: null,
    };
  },
  computed: {
    // 計算顯示範圍的起始頁
    startPage() {
      const half = Math.floor(this.maxVisiblePages / 2);
      return Math.max(2, this.pageNow - half); // 從第2頁開始
    },
    // 計算顯示範圍的結束頁
    endPage() {
      const half = Math.floor(this.maxVisiblePages / 2);
      return Math.min(this.pageAll - 1, this.pageNow + half); // 到倒數第2頁為止
    },
    // 中間可見頁面
    visiblePages() {
      const pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  created: function () {
    // Vue.axios
    //   .get(
    //     this.$store.state.src + this.$store.state.subDirectory + "/Html/FestivalHome",
    //     {
    //       params: {
    //         lang: $cookies.get("gma_the_site_lang")
    //       },
    //     }
    //   )
    //   .then((response) => {
    //     this.FestivalHomeData = response.data;
    //     this.carouselItems = this.FestivalHomeData.carouselItems;
    //     if (this.FestivalHomeData.EventSeries_Category) {
    //       this.Keyword = "";
    //       this.pageNow = -1;
    //       this.perPage = 9;
    //       this.loadList(1);
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    if ($cookies.get("gma_the_site_lang") == "zh_tw") {
      this.FestivalHomeData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "carouselItems": [
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/a2de7d29-0cc4-49a5-af08-15108af2d41c.webp",
            "title": "金曲國際音樂節-5"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/8d280265-634d-4168-a15a-2221e97e7a44.webp",
            "title": "金曲國際音樂節-4"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/19d587b8-a026-49b1-a871-dd0c899e685a.webp",
            "title": "金曲國際音樂節-3"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/18e852f8-fe98-4b39-b8b6-4fd4edbe6063.webp",
            "title": "金曲國際音樂節-2"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/70389ba1-b37d-4a13-af78-26756acbd0b4.webp",
            "title": "金曲國際音樂節-1"
          }
        ],
        "EventSeries_Category": {
          "CId": 67,
          "MId": 10,
          "CategoryId": "4C200209-323C-4431-9C96-334804D77A17",
          "CategoryName": "系列活動",
          "ParentId": "65B0384D-5D9E-468E-9565-BDE3B4CFC048",
          "Description": null,
          "Type": 2,
          "Sort": 21,
          "SortType": 1,
          "IsVisible": true,
          "IsSyncNeedReview": false,
          "IsShowSub": false,
          "IsShowActivitySearch": false,
          "EnableRSS": false,
          "Lang": "zh_tw",
          "CreateTime": "2025-04-09T17:47:00.857",
          "LastEditTime": "2025-06-13T02:04:23.56",
          "o_id": null,
          "o_parent_id": null,
          "PMId": 0
        }
      };
    } else {
      this.FestivalHomeData = {
        "SiteUrl": "https://tavis.tw/gma/36th",
        "SiteLogo": "https://tavis.tw/gma/36th/Upload/Editor/95635b33-f644-44a6-9371-dc4a6ecaa672.webp",
        "carouselItems": [
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/741daa2d-e0c6-4e4a-967f-bc2b7830b6bd.webp",
            "title": "金曲國際音樂節-5"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/d1f954c6-1439-44e9-8fc9-0922ea613560.webp",
            "title": "金曲國際音樂節-4"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/2a71cee6-1d73-4dbe-b019-235e9fccba4a.webp",
            "title": "金曲國際音樂節-3"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/adb5702f-a235-45de-bd12-79c11264fc17.webp",
            "title": "金曲國際音樂節-2"
          },
          {
            "Src": "https://tavis.tw/gma/36th/Upload/Editor/5feb08f8-db20-4f54-80dc-5975b0154707.webp",
            "title": "金曲國際音樂節-1"
          }
        ],
        "EventSeries_Category": {
          "CId": 112,
          "MId": 10,
          "CategoryId": "CC701C3E-4F65-4E0F-8004-7D5FF0B87997",
          "CategoryName": "Events",
          "ParentId": "1A7ADB31-0758-44A5-A60E-24FF58B1BB67",
          "Description": null,
          "Type": 9,
          "Sort": 12,
          "SortType": 1,
          "IsVisible": true,
          "IsSyncNeedReview": false,
          "IsShowSub": false,
          "IsShowActivitySearch": false,
          "EnableRSS": false,
          "Lang": "en",
          "CreateTime": "2025-04-15T17:23:55.997",
          "LastEditTime": "2025-06-13T02:07:36.953",
          "o_id": null,
          "o_parent_id": null,
          "PMId": 0
        }
      };
    }
    this.carouselItems = this.FestivalHomeData.carouselItems;
    if (this.FestivalHomeData.EventSeries_Category) {
      fetch("/gma/36th/data/postlist/all/" + this.FestivalHomeData.EventSeries_Category.CId + ".json")
        .then(response_pl => response_pl.json())
        .then(data_pl => {
          this.Posts_All = data_pl;
          this.Keyword = "";
          this.pageNow = -1;
          this.perPage = 9;
          this.loadList(1);
        })
        .catch(error_pl => {
          console.error("載入JSON失敗：", error_pl);
        });
    }
  },
  mounted: function () {
    if ($cookies.isKey("gma_the_site_lang")) {
      i18n.locale = $cookies.get("gma_the_site_lang");
      this.local = $cookies.get("gma_the_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    loadList: function (page) {
      var that = this;
      if (that.pageNow == page) {
        return;
      }
      // $.ajax({
      //   url:
      //     this.$store.state.src +
      //     this.$store.state.subDirectory +
      //     "/Html/PostList",
      //   type: "post",
      //   data: {
      //     CId: that.FestivalHomeData.EventSeries_Category.CId,
      //     Keyword: that.Keyword,
      //     page: page,
      //     perPage: that.perPage,
      //     lang: $cookies.get("gma_the_site_lang"),
      //   },
      //   dataType: "json",
      //   error: function () { },
      //   success: function (res) {
      //     if (res.status == 1) {
      //       that.total = res.total;
      //       that.pageNow = page;
      //       that.Posts = res.Posts;
      //       that.perPage = res.perPage;
      //       that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
      //       window.scrollTo({
      //         top: 0,
      //         behavior: 'smooth'
      //       });
      //     }
      //   },
      // });
      if (that.Posts_All.status == 1) {
        that.total = that.Posts_All.total;
        that.pageNow = page;
        that.Posts = that.Posts_All.Posts.slice((page - 1) * that.perPage, page * that.perPage);
        that.perPage = that.perPage;
        that.pageAll = Math.max(Math.ceil(that.Posts_All.total / that.perPage), 1);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (Post.Blank) {
          window.open(Post.Url, "_blank");
        } else {
          location.href = Post.Url;
        }
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId/*, CId: this.FestivalHomeData.EventSeries_Category.CId*/ },
        });
      }
    },
    gotoPostLink(Post) {
      if (Post.Type == 1) {
        if (Post.Url.startsWith("/")) {
          return this.FestivalHomeData.SiteUrl + Post.Url;
        } else {
          return Post.Url;
        }
      } else {
        const routeData = this.$router.resolve({
          name: "Post",
          params: { PId: Post.PId/*, CId: this.FestivalHomeData.EventSeries_Category.CId*/ },
        });
        return routeData.href;
      }
    },
  },
};
</script>